import Vue from 'vue'
import VueRouter from 'vue-router'
import { BridgeNativeMethods } from '@/assets/js/jsbridge'
import { routesNoauth, routesAuth, routesNomatch } from './routes'
import store from '@/store'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [...routesNoauth, ...routesAuth, ...routesNomatch]
})

router.beforeEach((to, from, next) => {
  // 初始化桥接
  if (routesNoauth.findIndex(route => route.name === to.name) !== -1) {
    next()
  } else {
    if (store.state.token && store.state.userData != null) {
      next()
    } else {
      BridgeNativeMethods.getToken(res => {
        if (res.code == '0' || res.code == 0 && res.data !== null && (res.data.token !== null || res.data.token !== '')) {
          store.commit('setToken', res.data.token)
          store.commit('setRefreshToken', res.data.refreshToken)

          console.log('token init', res.data)

        } else {
          console.error("get token error")
        }

        BridgeNativeMethods.getUserInfo(res => {
          if (res.code == '0' || res.code == 0 && res.data !== null) {
            store.commit('setUserData', res.data)
            console.log('userinfo', res.data)
          }
          console.log("app init")
          next()
        })
      })
    }
  }

})

export default router
